<template>
  <div class="interference">    
    <v-speed-dial
      v-model="fab"
      top
      right
      direction="bottom"
      :open-on-hover="hover"
      :transition="transition"
      class="mr-5"
    >
      <template v-slot:activator>
        <v-btn v-model="fab" color="cyan darken-1" dark >
          <template v-if="fab">
            <v-icon>
              mdi-menu-up
            </v-icon>
          </template>
          <template v-else>
            <v-icon>
              mdi-menu-down
            </v-icon>
          </template>
            {{ $t("experiment.fab.reference") }}
        </v-btn>
      </template>
      <template>
        <v-btn dark color="indigo" @click="openLabManualDialog();getLabManual()">
          <v-icon>mdi-file-document</v-icon>
          {{ $t("experiment.fab.lab_manual") }}
        </v-btn>
      </template>
      <template>
        <v-btn  dark color="green"  @click="openSetupDialog(); getSetupPhoto()">
          <v-icon> mdi-image-search </v-icon>
          {{ $t("experiment.fab.setup_photo") }}
        </v-btn>
      </template>
      <!--video-->
      <template>
        <v-btn dark color="amber darken-3" @click="openVideoDemoDialog();getExperimentVideoDemo()">
          <v-icon>mdi-play-circle</v-icon>
          {{ $t("experiment.fab.video_demo") }}
        </v-btn>
      </template>
    </v-speed-dial>
    <v-row>
      <v-col xs="12" sm="4">
        <v-card>
          <v-card-text>
            <!--//camera-->
            <div>{{ $t('experiment.camera.camera_1_text') }}</div>
            <div class="clickable" @click="popCamera(api.camera_1)">
              <img
                :src="api.camera_1.url"
                ref="camera1Image"
                style="width: 100%; height: auto; object-fit: cover;"
              />
            </div>
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-text>
            <div>{{ $t('experiment.camera.camera_2_text') }}</div>
            <div class="clickable" @click="popCamera(api.camera_2)">
              <img
                :src="api.camera_2.url"
                ref="camera2Image"
                style="width: 100%; height: auto; object-fit: cover;"
              />
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col xs="12" sm="8">
        <v-expansion-panels v-model="controlPanel" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header color="green lighten-5">
              <h5> {{ $t("experiment.panel.control_header") }} </h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="control-content">
              <v-card class="p-3">
                <v-overlay absolute :value="loop_flag || loading">
                  <v-btn color="primary">
                    {{ $t("experiment.panel.operating_prompt") }}
                    <v-progress-circular
                      indeterminate
                      size="12"
                      class="ma-4"
                    ></v-progress-circular>
                  </v-btn>
                </v-overlay>
                <v-row no-gutters>
                  <v-col cols="3">
                    <v-subheader> 
                      <strong> {{ $t("experiment.panel.control.interference.laser") }} </strong>
                    </v-subheader>
                  </v-col>
                  <v-col cols="9">
                    <v-radio-group v-model="laser_status" row dense>
                      <v-radio
                        :label="laserLabel('red')"
                        value="red"
                        :disabled="(
                        ((!$parent.equipmentLock && !$parent.bookingLock) && $cookies.get('role')!='player' && controlAuth==false)
                        ||
                        ($parent.equipmentLock || $parent.bookingLock) && $cookies.get('role')=='player' && controlAuth==false
                        )"
                        @click="clientAction('setCommand', 'device_1', laser_status.toUpperCase()+'|'+power);"
                      ></v-radio>
                      <v-radio
                        :label="laserLabel('green')"
                        value="green"
                        :disabled="(
                        ((!$parent.equipmentLock && !$parent.bookingLock) && $cookies.get('role')!='player' && controlAuth==false)
                        ||
                        ($parent.equipmentLock || $parent.bookingLock) && $cookies.get('role')=='player' && controlAuth==false
                        )"
                        @click="clientAction('setCommand', 'device_1', laser_status.toUpperCase()+'|'+power);"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row class="mt-3" no-gutters>
                  <v-col cols="3">
                    <v-subheader> 
                      <strong>
                        {{ $t("experiment.panel.control.interference.laser_power") }}
                        <br>
                        {{ $t("experiment.panel.control.interference.laser_power_scale") }}
                        ({{ $t("experiment.panel.control.interference.laser_power_unit") }})
                        </strong>
                    </v-subheader>
                  </v-col>
                  <v-col  cols="7">                    
                    <v-slider
                      class="mt-4"
                      v-model="power"
                      thumb-label="always"
                      :disabled="(
                        ((!$parent.equipmentLock && !$parent.bookingLock) && $cookies.get('role')!='player' && controlAuth==false)
                        ||
                        ($parent.equipmentLock || $parent.bookingLock) && $cookies.get('role')=='player' && controlAuth==false
                        )"
                      @change="controlScale('setCommand', laser_status.toUpperCase(), power);"
                    ></v-slider>
                  </v-col>
                  <v-col col="2">
                    <v-text-field
                      v-model="power_temp"
                      outlined
                      type="number"
                      step="1"
                      min="0"
                      max="100"
                      :rules="[controlRules.power]"
                      @change="controlScale('setCommand', laser_status.toUpperCase(), power_temp);"
                      :disabled="(
                        ((!$parent.equipmentLock && !$parent.bookingLock) && $cookies.get('role')!='player' && controlAuth==false)
                        ||
                        ($parent.equipmentLock || $parent.bookingLock) && $cookies.get('role')=='player' && controlAuth==false
                        )"
                    />
                  </v-col>
                </v-row>
                <v-row class="mt-3" no-gutters>
                  <v-col cols="3">
                    <v-subheader> 
                      <strong>
                        {{ $t("experiment.panel.control.interference.slit_position") }}
                        <br>
                        {{ $t("experiment.panel.control.interference.slit_position_scale") }}
                        ({{ $t("experiment.panel.control.interference.slit_position_unit") }})
                      </strong>
                    </v-subheader>
                  </v-col>
                  <v-col  cols="7">
                    <v-slider
                      class="mt-4"
                      v-model="M_M1"
                      :max="180"
                      thumb-label="always"
                      :disabled="(
                        ((!$parent.equipmentLock && !$parent.bookingLock) && $cookies.get('role')!='player' && controlAuth==false)
                        ||
                        ($parent.equipmentLock || $parent.bookingLock) && $cookies.get('role')=='player' && controlAuth==false
                        )"
                      @change="controlScale('setCommand', 'M_M1MOVE', M_M1);"
                    ></v-slider>
                  </v-col>
                  <v-col col="2">
                    <v-text-field
                      v-model="M_M1_temp"
                      outlined
                      type="number"
                      step="1"
                      min="0"
                      max="180"
                      :rules="[controlRules.M_M1]"
                      @change="controlScale('setCommand', 'M_M1MOVE', M_M1_temp);"
                      :disabled="(
                        ((!$parent.equipmentLock && !$parent.bookingLock) && $cookies.get('role')!='player' && controlAuth==false)
                        ||
                        ($parent.equipmentLock || $parent.bookingLock) && $cookies.get('role')=='player' && controlAuth==false
                        )"
                    />
                  </v-col>
                </v-row>
                <v-row class="mt-3" no-gutters>
                  <v-col cols="3">
                    <v-subheader> 
                      <strong>
                        {{ $t("experiment.panel.control.interference.slit_sensor_distance") }}
                        <br>
                        {{ $t("experiment.panel.control.interference.slit_sensor_distance_scale") }}
                        ({{ $t("experiment.panel.control.interference.slit_sensor_distance_unit") }})
                      </strong>
                    </v-subheader>
                  </v-col>
                  <v-col cols="7">                    
                    <v-slider
                      class="mt-4"
                      v-model="M_M2"
                      step="8"
                      min="100"
                      max="420"
                      thumb-label="always"
                      :disabled="(
                        ((!$parent.equipmentLock && !$parent.bookingLock) && $cookies.get('role')!='player' && controlAuth==false)
                        ||
                        ($parent.equipmentLock || $parent.bookingLock) && $cookies.get('role')=='player' && controlAuth==false
                        )"
                      @change="controlScale('setCommand', 'M_M2MOVE', M_M2);"
                    ></v-slider>
                  </v-col>
                  <v-col col="2">
                    <v-text-field
                      v-model="M_M2_temp"
                      outlined
                      type="number"
                      step="8"
                      min="100"
                      max="420"
                      :rules="[controlRules.M_M2]"
                      @change="controlScale('setCommand', 'M_M2MOVE', M_M2_temp);"
                      :disabled="(
                        ((!$parent.equipmentLock && !$parent.bookingLock) && $cookies.get('role')!='player' && controlAuth==false)
                        ||
                        ($parent.equipmentLock || $parent.bookingLock) && $cookies.get('role')=='player' && controlAuth==false
                        )"
                    />
                  </v-col>
                </v-row>
                <v-row class="mt-3" no-gutters>
                  <v-col cols="3">
                    <v-subheader> 
                      <strong>
                        {{ $t("experiment.panel.control.interference.sensor_position") }}
                        <br>
                        {{ $t("experiment.panel.control.interference.sensor_position_scale") }}
                        ({{ $t("experiment.panel.control.interference.sensor_position_unit") }})
                      </strong>
                    </v-subheader>
                  </v-col>
                  <v-col  cols="7">                    
                    <v-slider
                      class="mt-4"
                      v-model="S_M1"
                      :max="130"
                      thumb-label="always"
                      :disabled="(
                        ((!$parent.equipmentLock && !$parent.bookingLock) && $cookies.get('role')!='player' && controlAuth==false)
                        ||
                        ($parent.equipmentLock || $parent.bookingLock) && $cookies.get('role')=='player' && controlAuth==false
                        )"
                      @change="controlScale('setCommand', 'S_M1MOVE', S_M1);"
                    ></v-slider>
                  </v-col>
                  <v-col col="2">
                    <v-text-field
                      v-model="S_M1_temp"
                      outlined
                      type="number"
                      step="1"
                      min="0"
                      max="130"
                      :rules="[controlRules.S_M1]"
                      @change="controlScale('setCommand', 'S_M1MOVE', S_M1_temp);"
                      :disabled="(
                        ((!$parent.equipmentLock && !$parent.bookingLock) && $cookies.get('role')!='player' && controlAuth==false)
                        ||
                        ($parent.equipmentLock || $parent.bookingLock) && $cookies.get('role')=='player' && controlAuth==false
                        )"
                    />
                  </v-col>
                </v-row>
                <v-row class="mt-3" no-gutters>
                  <v-col cols="3">
                    <v-subheader> 
                      <strong>                        
                        {{ $t("experiment.panel.control.interference.sensor_adjustment") }}
                        <br>
                        {{ $t("experiment.panel.control.interference.sensor_adjustment_scale") }}
                        ({{ $t("experiment.panel.control.interference.sensor_adjustment_unit") }})
                      </strong>
                    </v-subheader>
                  </v-col>
                  <v-col  cols="7">                    
                    <v-slider
                      class="mt-4"
                      v-model="S_M2"
                      :max="35"
                      thumb-label="always"
                      :disabled="(
                        ((!$parent.equipmentLock && !$parent.bookingLock) && $cookies.get('role')!='player' && controlAuth==false)
                        ||
                        ($parent.equipmentLock || $parent.bookingLock) && $cookies.get('role')=='player' && controlAuth==false
                        )"
                      @change="controlScale('setCommand', 'S_M2MOVE', S_M2);"
                    ></v-slider>
                  </v-col>
                  <v-col col="2">
                    <v-text-field
                      v-model="S_M2_temp"
                      outlined
                      type="number"
                      step="1"
                      min="0"
                      max="35"
                      :rules="[controlRules.S_M2]"
                      @change="controlScale('setCommand', 'S_M2MOVE', S_M2_temp);"
                      :disabled="(
                        ((!$parent.equipmentLock && !$parent.bookingLock) && $cookies.get('role')!='player' && controlAuth==false)
                        ||
                        ($parent.equipmentLock || $parent.bookingLock) && $cookies.get('role')=='player' && controlAuth==false
                        )"
                    />
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row no-gutters>
                  <v-col cols="3">
                    <v-subheader>
                      <strong>
                        {{ $t("experiment.panel.control.interference.scan_distance") }}
                        <br>
                        {{ $t("experiment.panel.control.interference.scan_distance_scale") }}
                        ({{ $t("experiment.panel.control.interference.scan_distance_unit") }})
                      </strong>
                    </v-subheader>
                  </v-col>
                  <v-col cols="7">
                    <v-slider
                      class="mt-4"
                      v-model="scan_distance"
                      :max="85"
                      thumb-label="always"
                      :disabled="(
                        ((!$parent.equipmentLock && !$parent.bookingLock) && $cookies.get('role')!='player' && controlAuth==false)
                        ||
                        ($parent.equipmentLock || $parent.bookingLock) && $cookies.get('role')=='player' && controlAuth==false
                        )"
                    ></v-slider>
                  </v-col>
                  <v-col col="2">
                    <v-text-field
                      v-model="scan_distance"
                      outlined
                      type="number"
                      step="1"
                      min="0"
                      max="85"
                      :rules="[controlRules.scan_distance]"
                      :disabled="(
                        ((!$parent.equipmentLock && !$parent.bookingLock) && $cookies.get('role')!='player' && controlAuth==false)
                        ||
                        ($parent.equipmentLock || $parent.bookingLock) && $cookies.get('role')=='player' && controlAuth==false
                        )"
                    />
                  </v-col>
                  <v-col cols="12"><small>{{ $t("experiment.panel.control.interference.measure_note") }}</small></v-col>
                </v-row>
                <v-row class="mt-3" no-gutters>
                  <v-col>
                    <div class="d-flex justify-end">
                    <v-btn class="ma-6" @click="controlScale('setChart', 'MEASURE', scan_distance);"
                      :disabled="(
                        S_M1+scan_distance > 130) || 
                        (((!$parent.equipmentLock && !$parent.bookingLock) && $cookies.get('role')!='player' && controlAuth==false)
                        ||
                        ($parent.equipmentLock || $parent.bookingLock) && $cookies.get('role')=='player' && controlAuth==false
                        )"
                    >
                      {{ $t("experiment.panel.control.interference.measure_btn") }}
                    </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header color="green lighten-5">
              <h5> {{ $t("experiment.panel.measure_header") }} </h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <apexchart
                v-if="$i18n.locale=='tc'"
                type="line"
                :options="options_chi"
                :series="series"
                ref="realtimeChart"
              >
              </apexchart>
              <apexchart
                v-else
                type="line"
                :options="options"
                :series="series"
                ref="realtimeChart"
              >
              </apexchart>
              <v-overlay absolute :value="loop_flag || loading">
                <v-btn color="primary">
                  {{ $t("experiment.panel.operating_prompt") }}
                  <v-progress-circular
                    indeterminate
                    size="12"
                    class="ma-4"
                  ></v-progress-circular>
                </v-btn>
              </v-overlay>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <!--//camera delete-->
    <!--CameraDialog v-model="camera_dialog" :camera="camera_dialog_camera" /-->
    <v-dialog v-model="dialog_lab_manual" max-width="700px" >
      <v-card class="pb-3">
        <v-toolbar dark color="green">
          <v-btn icon dark @click="closeLabManualDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("experiment.fab.dialog.lab_manual.header") }}</v-toolbar-title>
        </v-toolbar>
        <v-row justify="center" no-gutters>
          <v-col cols="11"  class="my-2 px-1">
            <v-row>              
              <v-col cols="12">
                <div v-if="lab_manual.school_chi.path!=null || lab_manual.school_en.path!=null">
                  <v-card class="p-1">
                    <v-card-text class="p-1">
                      <v-row>
                        <v-col class="" cols="12">
                          <div v-if="lab_manual.school_en.path!=null">
                            <v-icon class="p-1" color="primary">mdi-file-document-outline</v-icon><a :href="lab_manual.school_en.path" target="_BLANK">{{ lab_manual.school_en.filename }} {{ $t("experiment.fab.dialog.lab_manual.en_label") }}</a>
                          </div>
                          <div v-if="lab_manual.school_chi.path!=null">
                            <v-icon  class="p-1" color="primary">mdi-file-document-outline</v-icon><a :href="lab_manual.school_chi.path" target="_BLANK">{{ lab_manual.school_chi.filename }} {{ $t("experiment.fab.dialog.lab_manual.chi_label") }}</a>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </div>
                <div v-else-if="lab_manual.school_chi.path==null && lab_manual.school_en.path==null">
                  <v-card class="p-1">
                    <v-card-text class="p-1">
                      <v-row>
                        <v-col class="" cols="12">
                          <div v-if="lab_manual.suggested_en.path!=null">
                            <v-icon class="p-1" color="primary">mdi-file-document-outline</v-icon><a :href="lab_manual.suggested_en.path" target="_BLANK">{{ lab_manual.suggested_en.filename }} {{ $t("experiment.fab.dialog.lab_manual.en_label") }}</a>
                          </div>
                          <div v-if="lab_manual.suggested_chi.path!=null">
                            <v-icon  class="p-1" color="primary">mdi-file-document-outline</v-icon><a :href="lab_manual.suggested_chi.path" target="_BLANK">{{ lab_manual.suggested_chi.filename }} {{ $t("experiment.fab.dialog.lab_manual.chi_label") }}</a>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_setup" max-width="800px">
      <v-card>
        <v-toolbar dark color="green">
          <v-btn icon dark @click="closeSetupDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("experiment.fab.dialog.setup_photo.header") }}</v-toolbar-title>
          <!--v-spacer></v-spacer-->
        </v-toolbar>
        <v-carousel v-model="model" height="auto">
          <v-carousel-item
            v-for="(item,i) in setup_photos"
            :key="i"
            :src="item.src"
          >
          </v-carousel-item>
        </v-carousel>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_video_demo" max-width="700px" >
      <v-card class="pb-3">
        <v-toolbar dark color="green">
          <v-btn icon dark @click="closeVideoDemoDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("experiment.fab.dialog.video_demo.header") }}</v-toolbar-title>
        </v-toolbar>
        <v-row justify="center" no-gutters>
          <v-col cols="11"  class="my-2 px-1">
            <v-row>              
              <v-col cols="12">
                <div v-if="video_demo.school_chi.path!=null || video_demo.school_en.path!=null">
                  <v-card class="p-1">
                    <v-card-text class="p-1">
                      <v-row>
                        <v-col class="" cols="12">
                          <div v-if="video_demo.school_en.path!=null">
                            <v-icon class="p-1" color="primary">mdi-play-circle</v-icon><a :href="video_demo.school_en.path" target="_BLANK">{{ video_demo.school_en.filename }} {{ $t("experiment.fab.dialog.video_demo.en_label") }}</a>
                          </div>
                          <div v-if="video_demo.school_chi.path!=null">
                            <v-icon  class="p-1" color="primary">mdi-play-circle</v-icon><a :href="video_demo.school_chi.path" target="_BLANK">{{ video_demo.school_chi.filename }} {{ $t("experiment.fab.dialog.video_demo.chi_label") }}</a>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </div>
                <div v-else-if="video_demo.school_chi.path==null && video_demo.school_en.path==null">
                  <v-card class="p-1">
                    <v-card-text class="p-1">
                      <v-row>
                        <v-col class="" cols="12">
                          <div v-if="video_demo.suggested_en.path!=null">
                            <v-icon class="p-1" color="primary">mdi-play-circle</v-icon><a :href="video_demo.suggested_en.path" target="_BLANK">{{ video_demo.suggested_en.filename }} {{ $t("experiment.fab.dialog.video_demo.en_label") }}</a>
                          </div>
                          <div v-if="video_demo.suggested_chi.path!=null">
                            <v-icon  class="p-1" color="primary">mdi-play-circle</v-icon><a :href="video_demo.suggested_chi.path" target="_BLANK">{{ video_demo.suggested_chi.filename }} {{ $t("experiment.fab.dialog.video_demo.chi_label") }}</a>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <!--//camera-->
    <v-dialog v-model="dialog_camera" max-width="1000" >
      <v-card>
        <v-toolbar dark color="green">
          <v-btn icon dark @click="closeCameraDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("experiment.camera.dialog_header") }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-3">
          <img :src="dialog_camera_src.url" fluid
            ref="cameraImagePop"
            style="width: 100%; height: auto; object-fit: cover;"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ExperimentTitle from "@/components/ExperimentTitle.vue";
//camera delete
//import CameraDialog from "@/components/CameraDialog.vue";
import ExperimentBasic from "@/services/iot/api_basic_experiment";
export default {
  name: "interference",
  components: {
    ExperimentTitle,
    //camera delete
    //CameraDialog,    
  },
  mixins: [ExperimentBasic],
  data: function () {
    return {
      //camera
      dialog_camera: false,
      dialog_camera_src: {},
      controlAuth: true,
      model: 0,
      colors: [
        'primary',
        'secondary',
        'yellow darken-2',
        'red',
        'orange',
      ],
      dialog_setup: false,
      dialog_lab_manual: false,
      dialog_video_demo: false,
      checkEnd: true,
      override: false,
      btnDisable: false,
      direction: 'bottom',
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: true,
      right: true,
      bottom: false,
      left: false,
      transition: 'slide-y-reverse-transition',
      current: {
        username: null,
        user_level: "USER",
        school_id: null,
        auth_token: null,
        experiment: null,
        equipment_id: null,
        booking_id: null,
      },
      controlPanel: [0, 1],
      realTimePanel: 0,
      myJson: null,
      camera1_url: null,
      camera2_url: null,
      inte: null,
      laser_status: "red",
      step_status: "small",
      power: 0,
      power_temp: 0,
      M_M1: 0,
      M_M1_temp: 0,
      M_M2: 0,
      M_M2_temp: 0,
      S_M1: 0,      
      S_M1_temp: 0,
      S_M2: 0,
      S_M2_temp: 0,
      controlRules: {
        power: value => { return (value>=0 && value<=100) || 'Out of range' },
        M_M1: value => { return (value>=0 && value<=180) || 'Out of range' },
        M_M2: value => { return (value>=100 && value<=420) || 'Out of range' },
        S_M1: value => { return (value>=0 && value<=130) || 'Out of range' },
        S_M2: value => { return (value>=0 && value<=35) || 'Out of range' },
        scan_distance: value => { return (value>=0 && value<=85) || 'Out of range' },
      },
      scan_distance:0,
      loading: false,
      loop_flag: false,
      distance: 0,
      setup_photos: [],
      lab_manual:{
        school_chi: { path: null, filename: null },
        school_en: { path: null, filename: null },
        suggested_chi: { path: null, filename: null },
        suggested_en: { path: null, filename: null },
      },    
      video_demo:{
        school_chi: { path: null, filename: null },
        school_en: { path: null, filename: null },
        suggested_chi: { path: null, filename: null },
        suggested_en: { path: null, filename: null },
      },
      api: {
        value: "",
        value_got_at: null,
        value_set_at: null,
        camera_1: "",
        camera_2: "",
      },
      options: {
        width: "100%",
        stroke: {
          width: 1,
        },
        yaxis: {
          title: {
            text: "Intensity (arb. unit)",
          },
        },
        xaxis: {
          type: 'numeric',
          title: {
            text: "Distance (mm)",
            offsetY: 10,
          },
          tickAmount: 10,
          labels: {
            formatter: function(val) {
              return parseFloat(val).toFixed(1);
            }
          }
        },
      },
      options_chi: {
        width: "100%",
        stroke: {
          width: 1,
        },yaxis: {
          title: {
            text: "強度 (任意單位)",
          },
        },
        xaxis: {
          type: 'numeric',
          title: {
            text: "距離 (毫米)",
            offsetY: 10,
          },
          tickAmount: 10,
          labels: {
            formatter: function(val) {
              return parseFloat(val).toFixed(1);
            }
          }
        },
      },
      series: [
        {
          data: [

          ],
        },
      ],
    };
  },
  mounted: function () {
    var self = this;
    self.checkEnd = self.$parent.checkEnd;
    self.override = self.$parent.override
    self.current.school_id = self.$store.state.user.school_id;
    self.current.username = self.$store.state.user.username;
    self.current.user_level = self.$store.state.user.user_level;
    self.current.auth_token = self.$store.state.user.auth_token;
    self.school_id = self.$route.params.school_id;
    self.experiment = self.$route.query.experiment;
    self.equipment_id = self.$route.query.equipment;    
    self.getValue("camera_1", function () {
      self.api.camera_1 = self.api.value;
      self.getValue("camera_2", function () {
        self.api.camera_2 = self.api.value;
        self.getValue("device_1", function () {
          self.M_M1 = self.api.value.M_M1 * 0.1;
          self.M_M2 = self.api.value.M_M2 * 8 + 100;
          self.S_M1 = self.api.value.S_M1 * 0.1;
          self.S_M2 = self.api.value.S_M2 * 0.1;
          self.M_M1_temp = self.M_M1;
          self.M_M2_temp = self.M_M2;
          self.S_M1_temp = self.S_M1;
          self.S_M2_temp = self.S_M2;
          if(self.api.value.red!=0){
            self.power = self.api.value.red;
            self.power_temp = self.power;
            self.laser_status='red';
          }
          else if(self.api.value.green!=0){
            self.power = self.api.value.green;
            self.power_temp = self.power;
            self.laser_status='green';
          }
          else {
            self.power = 0;
            self.power_temp = 0;
          }
          self.getChart("device_1");
        });
      });
    });
    self.checkOverrided();
    setInterval(function () {
      //loop distance value
      if (self.loop_flag) {
        self.getValue("device_1", function () {
          if (self.api.value_set_at >= self.api.command_set_at) {
            self.loop_flag = false;
            self.M_M1 = self.api.value.M_M1 * 0.1;
            self.M_M2 = self.api.value.M_M2 * 8 + 100;
            self.S_M1 = self.api.value.S_M1 * 0.1;
            self.S_M2 = self.api.value.S_M2 * 0.1;
            self.M_M1_temp = self.M_M1;
            self.M_M2_temp = self.M_M2;
            self.S_M1_temp = self.S_M1;
            self.S_M2_temp = self.S_M2;
            if(self.api.value.red!=0){
              self.power = self.api.value.red;
              self.power_temp = self.power;
              self.laser_status='red';
            }
            else if(self.api.value.green!=0){
              self.power = self.api.value.green;
              self.power_temp = self.power;
              self.laser_status='green';
            }            
            else {
              self.power = 0;
              self.power_temp = 0;
            }
          }
        });
      }
    }, 1000);    
  },
  methods: {
    //camera
    popCamera(camera) {
      var self = this;
      self.dialog_camera_src = camera;
      self.dialog_camera = true;
    },
    openCameraDialog(){
      var self = this;
      self.dialog_camera = true;
    },
    closeCameraDialog(){
      var self = this;
      self.dialog_camera = false;
      self.dialog_camera_src = {};
    },
    laserLabel(color){
      var self = this;
      if(color=='red'){
        if(self.$i18n.locale=='tc') return '紅';
        else return 'Red';
      }
      else if(color=='green'){
        if(self.$i18n.locale=='tc') return '綠';
        else return 'Green';
      }
    },
    controlScale(type, command, value){
      var self = this;
      let device_id = "device_1";      
      if(isNaN(value) || value==""){
        if (command == "RED" || command == "GREEN") value = self.power;
        else if(command == "M_M1MOVE") value = self.M_M1;
        else if(command == "M_M2MOVE") value = self.M_M2;
        else if(command == "S_M1MOVE") value = self.S_M1;
        else if(command == "S_M2MOVE") value = self.S_M2;
        else if(command == "MEASURE") value = self.scan_distance;
      }
      else {
        if( (command == "RED" || command == "GREEN") && (value<0 || value>100 )) return;
        else if( command == "M_M1MOVE" && (value<0 || value>180 )) return;
        else if( command == "M_M2MOVE" && (value<100 || value>420 )) return;
        else if( command == "S_M1MOVE" && (value<0 || value>130 )) return;
        else if( command == "S_M2MOVE" && (value<0 || value>35 )) return;
        else if( command == "MEASURE" && (value<0 || value>85 )) return;
      }
      if(type=="setCommand"){
         
        if(command == "M_M1MOVE" || command == "S_M1MOVE" || command == "S_M2MOVE"){          
          value = value / 0.1;
        }
        else if(command == "M_M2MOVE"){
          value = (value - 100) / 8
        }
      }
      else if(type=="setChart"){
        value = value / 0.1;
      }
      setTimeout(function(){
        self.clientAction(type, device_id, command + "|" + value);
      }, 250);
      //self.clientAction('setCommand', 'device_1', 'M_M1MOVE|'+M_M1)
    },
    openLabManualDialog(){
      var self = this;
      self.dialog_lab_manual = true;
    },
    closeLabManualDialog(){
      var self = this;
      self.dialog_lab_manual = false;
    },
    openSetupDialog(){
      var self = this;
      self.dialog_setup = true;
    },
    closeSetupDialog(){
      var self = this;
      self.dialog_setup = false;
    },  
    openVideoDemoDialog(){
      var self = this;
      self.dialog_video_demo = true;
    },
    closeVideoDemoDialog(){
      var self = this;
      self.dialog_video_demo = false;
    },
    changeCheck(){
      var self = this;
      self.$emit("changeCheck");
      self.checkEnd = self.$parent.checkEnd;
    },
  },
  //camera
  beforeDestroy() {
    if (this.$refs.camera1Image) {
      this.$refs.camera1Image.src = '';
    }
    if (this.$refs.camera2Image) {
      this.$refs.camera2Image.src = '';
    }
    if (this.$refs.cameraImagePop) {
      this.$refs.cameraImagePop.src = '';
    }
  },
  destroyed() {
    this.loop_flag = false;
    this.loading = false;
    clearInterval(this.inte);
  }
};
</script>
<style>
  /* This is for documentation purposes and will not be needed in your application */
  .v-speed-dial {
    position: absolute;
    z-index: 2;
  }

  .v-btn--floating {
    position: relative;
    z-index: 5;
  }

  .control-content>.v-expansion-panel-content__wrap{
    padding: 0;
  }
</style>
